module.exports = __webpack_public_path__ + "img/1535919535.acd78b54.jpg";